{
  "analytics_chart_frequency_d": "Ежедневно",
  "analytics_chart_frequency_h": "Каждый час",
  "analytics_chart_frequency_m": "Ежемесячно",
  "analytics_chart_frequency_w": "Еженедельно",
  "analytics_charts": "Графики",
  "analytics_date": "Дата",
  "analytics_description_empty": "Нет данных за выбранный период.",
  "analytics_event_bounce": "Возврат",
  "analytics_event_clicks": "Клик",
  "analytics_event_delivered": "Доставлено",
  "analytics_event_drop": "Сброс",
  "analytics_event_opens": "Открыто",
  "analytics_event_queued": "В очереди",
  "analytics_event_sent": "Доставлено",
  "analytics_event_spam": "Спам",
  "analytics_event_unsubscribes": "Отписан",
  "analytics_events": "События",
  "analytics_events_all": "Все",
  "analytics_events_bounce": "Возврат",
  "analytics_events_bounce_tooltip": "Процент и количество писем, отклоненных серверами ваших получателей.",
  "analytics_events_bounces": "Отказы",
  "analytics_events_clicks": "Клики",
  "analytics_events_clicks_tooltip": "Процент и количество людей, которые нажали хотя бы на одну ссылку в вашем сообщении.",
  "analytics_events_delivered": "Доставленные",
  "analytics_events_delivered_tooltip": "Процент и количество отправленных сообщений, успешно доставленных.",
  "analytics_events_drop": "Сброс",
  "analytics_events_drop_tooltip": "Эти имейлы исключены из списка, так как ранее получатели отказывались от подписки, жаловались на спам и приходили сообщения о возврате. Исключённые имейлы перечислены в разделе «Изъятие из списка»",
  "analytics_events_opens": "Открытые",
  "analytics_events_opens_tooltip": "Процент и количество писем, открытых вашими получателями.",
  "analytics_events_queued": "В очереди",
  "analytics_events_queued_tooltip": "Процент от общего числа имейлов, находящихся в очереди на отправку.",
  "analytics_events_sent": "Доставленные",
  "analytics_events_spam": "Спам",
  "analytics_events_spam_tooltip": "Процент получателей, которые сообщили о доставленном сообщении как о спаме.",
  "analytics_events_unsubscribes": "Отписавшиеся",
  "analytics_events_unsubscribes_tooltip": "Процент запросов на отмену подписки в результате успешно доставленных имейлов.",
  "analytics_file": "Имя файла",
  "analytics_filterby_domain": "Домен",
  "analytics_filterby_recipient": "Получатель",
  "analytics_filterby_sender": "Отправитель",
  "analytics_filterby_subject": "Тема",
  "analytics_overview": "Обзор",
  "analytics_recipient": "Получатель",
  "analytics_sender": "Отправитель",
  "analytics_status": "Статус",
  "analytics_subject": "Тема",
  "analytics_temporary_error": "Произошла временная ошибка. Попробуйте еще раз позже.",
  "analytics_title": "Аналитика",
  "analytics_total_emails": "Загруженные письма",
  "analytics_total_processed": "Обработанные письма",
  "analytics_upload_date": "Дата загрузки",
  "and": "и",
  "annually": "Ежегодно",
  "billing_changepassword_description": "Измените ваш пароль в этой области. Этот пароль используется только для доступа к Dashboard.",
  "billing_changepassword_title": "Изменить пароль",
  "billing_contact_were_not_found": "Платежный контакт не найден.",
  "billing_contacts_address": "Адрес",
  "billing_contacts_address2": "Адрес №2",
  "billing_contacts_billing": "Электронные счета-фактуры — счета-фактуры и напоминания о выставлении счетов",
  "billing_contacts_button_add": "Добавить",
  "billing_contacts_button_edit": "Редактировать",
  "billing_contacts_city": "Город",
  "billing_contacts_company": "Название компании",
  "billing_contacts_country": "Страна",
  "billing_contacts_editcontact": "Редактировать контакт",
  "billing_contacts_email": "Адрес эл. почты",
  "billing_contacts_empty": "Письма будут отправляться на адрес, указанный в основном аккаунте. Добавьте адреса для отправки сообщений дополнительным получателям.",
  "billing_contacts_firstname": "Имя",
  "billing_contacts_lastname": "Фамилия",
  "billing_contacts_marketing": "Служебные электронные письма — уведомления о продлении, подтверждения регистрации и т. д.",
  "billing_contacts_phone": "Номер телефона",
  "billing_contacts_products": "Письма о продуктах — информация о заказах, приветственные письма и т. д.",
  "billing_contacts_slide_description": "Письма будут отправляться на адрес, указанный в основном аккаунте. Добавьте адреса для отправки сообщений дополнительным получателям.",
  "billing_contacts_slide_title": "Добавить новый контакт",
  "billing_contacts_stateregion": "Штат/регион/провинция",
  "billing_contacts_subscriptions": "Услуги",
  "billing_contacts_support": "Письма службы поддержки — разрешите этому пользователю открывать заявки из вашего аккаунта.",
  "billing_contacts_terms": "Я прочитал(-а) и согласен(-на) с Политикой конфиденциальности и Условиями использования",
  "billing_contacts_title": "Добавить контакты",
  "billing_contacts_transactional": "Общие электронные письма — объявления общего характера и напоминание пароля",
  "billing_contacts_zip": "Индекс",
  "billing_details_contact_above": "Отправить только контакту по умолчанию",
  "billing_emails_sentdate": "Дата отправления",
  "billing_emails_subject": "Тема",
  "billing_invoice_date": "Дата отправления",
  "billing_invoice_duedate": "Крайний срок",
  "billing_invoice_number": "Номер",
  "billing_invoice_status": "Статус",
  "billing_invoice_status_cancelled": "Отменено",
  "billing_invoice_status_paid": "Уплачено",
  "billing_invoice_status_refunded": "Возвращено",
  "billing_invoice_status_unpaid": "Не уплачено",
  "billing_invoice_total": "Всего",
  "billing_product_payment_method_banktransfer": "Банковский перевод",
  "billing_product_paymentmethod_avangate": "Кредитная карта (2Checkout)",
  "billing_product_paymentmethod_stripe": "Кредитная карта (Stripe)",
  "button_add_contact": "Добавить контакт",
  "button_add_filter": "Добавить фильтр",
  "button_add_plan": "Заказать новый план",
  "button_add_subaccount": "Добавить субаккаунт",
  "button_add_suppression": "Добавить подавление",
  "button_add_template": "Добавить шаблон",
  "button_addbcc": "Добавить скрытую копию",
  "button_addfooter": "Добавить нижний колонтитул",
  "button_advanced_search": "Расширенный поиск",
  "button_apply": "Применить",
  "button_back": "Назад",
  "button_basic_search": "Базовый поиск",
  "button_buycredits": "Купить кредиты",
  "button_cancel": "Отменить",
  "button_close": "Закрыть",
  "button_contact_us": "связаться с нами",
  "button_create": "Создать",
  "button_createalert": "Создать оповещение",
  "button_delete": "Удалить",
  "button_delete_all": "Удалить все",
  "button_delete_filtered": "Удалить отфильтрованные",
  "button_delete_selected": "Удалить выбранное ({n})",
  "button_edit": "Редактировать",
  "button_export": "Экспортировать",
  "button_import": "Импорт файла",
  "button_limits": "Установить лимиты",
  "button_more": "Подробнее",
  "button_next": "Далее",
  "button_refresh": "Перезагрузить",
  "button_request_cancellation": "Запрос на отмену",
  "button_reset": "Сбросить",
  "button_returnlist": "Вернуться к списку",
  "button_save": "Сохранить",
  "button_search": "Поиск",
  "button_select_fromdevice": "Выберите файлы с вашего устройства",
  "button_unsubscribe": "Добавить ссылку «Отписаться»",
  "button_update": "Обновить",
  "button_update_template": "Обновить шаблон",
  "button_update_unsubscribe": "Обновить ссылку «Отписаться»",
  "button_updatealert": "Обновить уведомление",
  "button_updatebcc": "Обновить скрытую копию",
  "button_updatefooter": "Обновить нижний колонтитул",
  "confirm_password_is_missing": "Поле «Подтвердите пароль» является обязательным.",
  "dashboard_clicked": "Клики",
  "dashboard_delivered": "Доставленные",
  "dashboard_emails_sent": "Всего писем",
  "dashboard_emails_sent_out_of": "Письма, отправленные из",
  "dashboard_gotoanalytics": "Перейти к аналитике",
  "dashboard_new_version": "Доступна обновленная версия!",
  "dashboard_new_version_cancel": "ОК",
  "dashboard_new_version_description": "Сначала сохраните свою работу, затем перезагрузите страницу<br> или нажмите «Обновить сейчас», чтобы загрузить новую версию.",
  "dashboard_new_version_ok": "Обновлено",
  "dashboard_plan_emails": "электронные письма",
  "dashboard_plan_label": "План",
  "dashboard_plan_label_interval": "{interval} план",
  "dashboard_plan_limit_unit_daily": "день",
  "dashboard_plan_limit_unit_monthly": "месяц",
  "dashboard_plan_limit_unit_yearly": "год",
  "dashboard_recent_email_activities": "Недавние действия с электронной почтой",
  "dashboard_try": "Вы используете бесплатную пробную версию. Чтобы просмотреть полную панель инструментов:",
  "datepicker_last_3_months": "Последние 3 месяца",
  "datepicker_last_30days": "Последние 30 дней",
  "datepicker_last_month": "Прошлый месяц",
  "datepicker_last_sevendays": "Последние 7 дней",
  "datepicker_last_week": "Прошлая неделя",
  "datepicker_last_year": "Прошлый год",
  "datepicker_this_month": "Этот месяц",
  "datepicker_this_year": "Этот год",
  "datepicker_today": "Сегодня",
  "datepicker_yesterday": "Вчера",
  "delete_all_bounce": "Удалить все отказы",
  "delete_all_manual": "Удалить установленное вручную",
  "delete_all_spam": "Удалить весь спам",
  "delete_all_unsubscribe": "Удалить все отписки",
  "delete_fist_login_dont": "Не показывать это сообщение снова.",
  "delete_fist_login_one": "<h3>Добро пожаловать в расширенную панель управления turboSMTP</h3><p>В режиме реального времени просматривайте статистику своих кампаний по рассылке<br> и улучшайте результативность с помощью профессиональных инструментов.</p><h4>Чтобы настроить панель, следуйте инструкциям.</h4>",
  "delete_fist_login_three_a": "Укажите имя SMTP-сервера в почтовом клиенте.",
  "delete_fist_login_three_b": "<p><strong class=\"font-xxl\">pro.turbo-smtp.com</strong></p>",
  "delete_fist_login_three_c": "Не забудьте настроить DNS-записи для своего домена. <br>Параметры вы найдете в «Настройках».",
  "delete_fist_login_two_a": "<h3>Открытое отслеживание</h3><p>позволяет turboSMTP отслеживать процент открытия ваших сообщений.</p>",
  "delete_fist_login_two_b": "<h3>Отслеживание кликов</h3><p>позволяет turboSMTP отслеживать показатели кликов для ваших сообщений.</p>",
  "editor_quill_button_title": "Показать HTML-код",
  "editor_quill_cancel_text": "Отменить",
  "editor_quill_msg": "Редактировать содержимое в формате HTML",
  "editor_quill_ok_text": "ОК",
  "emails_month": "писем в месяц",
  "emailvalidator_add_file": "Добавить файл",
  "emailvalidator_add_form_errors": "Ошибки формы",
  "emailvalidator_add_form_nofile_selected": "Файл не выбран",
  "emailvalidator_add_value": "Вы можете добавить между",
  "emailvalidator_attention": "Внимание!",
  "emailvalidator_available": "бесплатные кредиты",
  "emailvalidator_balance_description": "Ваш кредитный баланс",
  "emailvalidator_balance_title": "Ваш проверочный баланс",
  "emailvalidator_buy_extra_credit": "Купить дополнительный кредит",
  "emailvalidator_complete": "Завершить",
  "emailvalidator_confirm_delete_label": "Подтвердите действие",
  "emailvalidator_confirm_delete_text": "Вы хотите удалить этот список?",
  "emailvalidator_contact_support": "<a href=\"https://serversmtp.com/en/submitticket.php\" target=\"_blank\">Связаться с поддержкой <i class=\"ml-2 pi pi-external-link\"></i></a>",
  "emailvalidator_cost_per_email": "Затраты на одно электронное письмо",
  "emailvalidator_date": "Дата создания:",
  "emailvalidator_day": "День",
  "emailvalidator_details_empty": "внутри нет элементов",
  "emailvalidator_domain": "Домен",
  "emailvalidator_domain_age": "Срок службы домена",
  "emailvalidator_email": "Адрес электронной почты",
  "emailvalidator_email_addesses": "адреса электронной почты",
  "emailvalidator_empty": "Загруженный файл должен содержать только один адрес электронной почты в каждой строке. Допустимые форматы файлов: csv и txt. Выберите файл для загрузки.",
  "emailvalidator_entry_details": "Сведения о проверке",
  "emailvalidator_error": "Ошибка",
  "emailvalidator_error_contact_support": "Ошибка: обратитесь в службу поддержки!",
  "emailvalidator_expiring": "срок истекает",
  "emailvalidator_export": "Экспортировать",
  "emailvalidator_free_email": "Бесплатный почтовый ящик",
  "emailvalidator_how_many": "Сколько писем вы хотите проверить?",
  "emailvalidator_list_contains": "В загруженном списке",
  "emailvalidator_list_not_removed": "Ошибка при удалении списка",
  "emailvalidator_list_removed": "Список успешно удален.",
  "emailvalidator_mx_record": "запись MX",
  "emailvalidator_please_enter_amout": "Введите сумму, которую вы хотите добавить в свой виртуальный кошелек.",
  "emailvalidator_price_calculator": "Калькулятор цены",
  "emailvalidator_price_email": "Цена за электронное письмо",
  "emailvalidator_process_now": "Обработать сейчас",
  "emailvalidator_refresh": "обновить",
  "emailvalidator_slide_description": "Файл должен состоять из одного столбца, содержащего все адреса электронной почты, которые вы хотите импортировать.",
  "emailvalidator_slide_details_description": "Допустимые форматы файлов: csv или txt.",
  "emailvalidator_slide_details_title": "Перетащите файл сюда.",
  "emailvalidator_slide_manually_description": "Скопируйте и вставьте несколько адресов электронной почты в область ниже, разделив их концевой чертой.",
  "emailvalidator_slide_manually_title": "Добавить вручную",
  "emailvalidator_smpt_provider": "SMTP-провайдер",
  "emailvalidator_status": "Статус",
  "emailvalidator_status_abuse": "Ошибочное употребление",
  "emailvalidator_status_catch_all": "«Ящик-ловушка»",
  "emailvalidator_status_do_not_mail": "Не направляйте по почте",
  "emailvalidator_status_invalid": "Неверный адрес",
  "emailvalidator_status_spamtrap": "Спам",
  "emailvalidator_status_unknown": "Получатель неизвестен",
  "emailvalidator_status_valid": "Действителен",
  "emailvalidator_title": "Валидатор электронной почты",
  "emailvalidator_total_cost": "Общие затраты",
  "emailvalidator_upload_warning": "Ваш текущий кредитный баланс составляет {current_balance}. Вам необходимо приобрести {needed_balance} дополнительного кредита, чтобы проверить подлинность этого списка...",
  "emailvalidator_validate_list": "Проверить список",
  "emailvalidator_validate_now": "Проверить сейчас",
  "emailvalidator_validated_lists": "Проверенные списки",
  "emailvalidator_validation_date": "Дата проверки",
  "emailvalidator_value": "Значение",
  "emailvalidator_you_have": "У вас осталось",
  "empty_authorization_token": "Отсутствует токен авторизации",
  "empty_request_body": "Запрос неполный",
  "error": "ошибка",
  "file_too_large": "file_too_large",
  "filter": "Фильтр",
  "filter_by": "Фильтр по",
  "filter_fuzzy": "Умный поиск",
  "filter_fuzzy_description": "Включите эту функцию, чтобы возвращать элементы, похожие на поисковый запрос.",
  "filter_placeholder_analytics": "Поиск...",
  "filter_placeholder_suppressions": "Поиск...",
  "filter_suppressions_placeholder": "Поиск по получателю, отправителю, теме электронного письма или причине блокировки.",
  "filters_show": "Показать фильтры",
  "filters_hide": "Скрыть фильтры",
  "first_login_step": "Шаг {n}",
  "forgot_password_changed": "Пароль изменен.",
  "forgot_password_click": "Нажмите здесь",
  "forgot_password_confirm": "Повторите пароль",
  "forgot_password_done": "Готово!",
  "forgot_password_donot_match": "Пароли не совпадают.",
  "forgot_password_email_not_found": "Адрес электронной почты не найден",
  "forgot_password_enter_email": "Введите свой электронный адрес",
  "forgot_password_error": "Произошла ошибка при смене пароля.",
  "forgot_password_expired": "Истек срок действия электронного письма для сброса пароля.",
  "forgot_password_pick": "Выберите пароль",
  "forgot_password_please_reset": "Установите свой пароль",
  "forgot_password_recovery_email_sent": "Письмо для восстановления отправлено",
  "forgot_password_resend": "чтобы отправить электронное письмо еще раз.",
  "forgot_password_reset": "Сбросить пароль",
  "forgot_password_send_password_reset_link": "Отправить ссылку для сброса пароля",
  "forgot_password_sent_email_to_update_password": "Мы отправили вам письмо со ссылкой для смены пароля.",
  "forgot_password_set": "Задайте новый пароль",
  "forgot_password_should_have": "Что должно быть в пароле:",
  "forgot_password_suggestions": "<li>минимум одна строчная буква,</li> <li>минимум одна заглавная буква,</li><li>минимум одна цифра,</li><li>минимум 10 символов</li>.",
  "forgot_password_switch": "Переключиться на вход",
  "forgot_password_switch_to_login": "Переключиться на вход",
  "forgot_password_token_is_missing": "Токен для забытого пароля отсутствует",
  "forgot_password_unable_to_send": "Невозможно отправить электронное письмо.",
  "forgot_password_username": "Электронный адрес пользователя username",
  "forgot_password_we_will_send_you": "Мы вышлем вам ссылку для восстановления пароля.",
  "free_account": "Бесплатный аккаунт",
  "friday": "Пятница",
  "fuzzy_tooltip": "Включите эту функцию, чтобы возвращать элементы, похожие на поисковый запрос",
  "header_menu_support": "https://serversmtp.com/multilanguage-customer-support/",
  "internal_server_error_try_again": "Внутренняя ошибка сервера. Попробуйте еще раз позже.",
  "invalid_authorization_token": "Токен авторизации недействителен",
  "invalid_limit_parameter_value_must_be_greater_than_or_equals_1": "Предельное значение должно быть не менее 1",
  "invalid_page_parameter_value_must_be_greater_than_or_equals_1": "Значение страницы должно быть не менее 1",
  "invalid_value_for_orderby_parameter": "Параметр «упорядочить по» недействителен.",
  "invalid_value_for_the_parameter_type": "Недопустимое значение для параметра",
  "invoice_not_found": "Счет-фактура не найден",
  "jwt_error_full_details": "Полная информация",
  "jwt_error_status": "HTTP-статус",
  "jwt_error_url": "URL",
  "jwt_url_not_exists": "Указанный ниже URL не существует",
  "l_dont_have_account": "У вас еще нет аккаунта?",
  "l_email_address": "Адрес эл. почты",
  "l_forgot_password": "Забыли пароль?",
  "l_login": "Войти",
  "l_password": "Пароль",
  "l_remember_me": "Оставаться в системе.",
  "l_sign_up_here": "Зарегистрируйтесь здесь",
  "l_username_email": "электронный адрес пользователя username",
  "l_welcome_back": "С возвращением!",
  "language_changed_label": "Вы изменили язык",
  "language_changed_message": "Чтобы обновить язык, перезагрузите страницу",
  "language_changed_reload": "Перезагрузить",
  "m_accountinfo": "Данные аккаунта",
  "m_analytics": "Аналитика",
  "m_billing": "Счета-проформы",
  "m_dashboard": "Панель управления",
  "m_emailsentout": "письма, отправленные из",
  "m_emailvalidator": "Валидатор электронной почты",
  "m_messages": "Системные сообщения",
  "m_myaccount": "Мой аккаунт",
  "m_mydetails": "Мой аккаунт",
  "m_noplans": "Нет планов",
  "m_of": "",
  "m_products": "Мои товары",
  "m_savechanges": "Сохранить изменения",
  "m_settings": "Настройки",
  "m_subaccounts": "Субаккаунты",
  "m_suppressions": "Подавления",
  "m_tickets": "Мои билеты",
  "m_validuntil": "Действует до",
  "missing_or_invalid_value_provided_for_whiteLabeled_variable": "Отсутствует или указано неверное значение для переменной WhiteLabeled",
  "missing_required_parameter": "Обязательный параметр отсутствует",
  "missing_required_parameter_email": "Отсутствует электронная почта",
  "missing_required_parameter_from": "Данные «От кого» отсутствуют",
  "missing_required_parameter_to": "Данные «Кому» отсутствуют",
  "missing_required_parameter_tz": "Данные «От кого» отсутствуют",
  "modal_confirmation": "Подтверждение",
  "monday": "Понедельник",
  "monthly": "Ежемесячно",
  "my_account_title": "Мой аккаунт",
  "myaccount_2fa_title": "Двухфакторная аутентификация",
  "myaccount_2fa_description": "Повысьте безопасность своего аккаунта, включив двухфакторную аутентификацию (2FA). Это добавляет дополнительный уровень защиты вашему аккаунту.",
  "myaccount_2fa_card_description": "Включите двухфакторную аутентификацию для защиты вашего аккаунта.",
  "myaccount_2fa_select_method": "Выбрать метод аутентификации",
  "myaccount_2fa_method": "Метод аутентификации",
  "myaccount_2fa_method_placeholder": "Выберите метод аутентификации",
  "myaccount_2fa_otp_description": "Используйте приложение-аутентификатор (например, Google Authenticator или Authy) для генерации кодов на основе времени.",
  "myaccount_2fa_email_description": "Получайте коды подтверждения по электронной почте.",
  "myaccount_2fa_sms_description": "Получайте коды подтверждения по SMS.",
  "myaccount_2fa_none_description": "Отключите двухфакторную аутентификацию для вашего аккаунта.",
  "myaccount_2fa_scan_qr": "Сканировать QR-код",
  "myaccount_2fa_scan_qr_description": "Отсканируйте этот QR-код с помощью приложения-аутентификатора для настройки двухфакторной аутентификации.",
  "myaccount_2fa_manual_entry": "Или введите этот код вручную:",
  "myaccount_2fa_copy_secret": "Копировать в буфер обмена",
  "myaccount_2fa_secret_copied": "Секретный ключ скопирован в буфер обмена",
  "myaccount_2fa_verify_code": "Подтвердить код",
  "myaccount_2fa_enter_code": "Введите код подтверждения",
  "myaccount_2fa_code_placeholder": "000000",
  "myaccount_2fa_verify_code_description": "Введите 6-значный код из приложения-аутентификатора для завершения настройки.",
  "myaccount_2fa_method_updated": "Метод двухфакторной аутентификации успешно обновлён",
  "myaccount_2fa_otp_enabled": "Двухфакторная аутентификация успешно включена",
  "myaccount_2fa_current_status": "Текущий статус",
  "myaccount_2fa_status": "Статус двухфакторной аутентификации",
  "myaccount_2fa_status_disabled": "Отключена",
  "myaccount_2fa_error_no_keycloak_id": "Не удалось настроить 2FA: идентификатор пользователя не найден",
  "myaccount_2fa_error_invalid_code": "Неверный код подтверждения. Пожалуйста, попробуйте ещё раз.",
  "myaccount_2fa_error_generic": "При настройке двухфакторной аутентификации произошла ошибка",
  "myaccount_2fa_enabled": "Включена",
  "myaccount_2fa_disabled_label": "Отключена",
  "myaccount_2fa_disabled": "Двухфакторная аутентификация успешно отключена",
  "myaccount_account_details": "Мой аккаунт",
  "myaccount_billing": "Счета-проформы",
  "myaccount_billing_contacts": "Управление контактами",
  "myaccount_billing_contacts_description": "Письма будут отправляться на адрес, указанный в основном аккаунте. Добавьте адреса для отправки сообщений дополнительным получателям.",
  "myaccount_billing_description": "В этом разделе вы можете найти счета-проформы, выставленные до налоговых счетов-фактур.<br>nНалоговые счета будут отправлены вам по электронной почте.",
  "myaccount_billing_details": "Аккаунт и платежные реквизиты",
  "myaccount_billing_details_address": "Адрес",
  "myaccount_billing_details_address2": "Адрес №2",
  "myaccount_billing_details_billing_company_name": "Компания-плательщик",
  "myaccount_billing_details_billing_contact": "Отправка счетов-проформ на адрес, отличный от адреса в аккаунте",
  "myaccount_billing_details_billing_vat": "НДС / P. IVA / C. F.",
  "myaccount_billing_details_billing_website": "Веб-сайт",
  "myaccount_billing_details_city": "Город",
  "myaccount_billing_details_country": "Страна",
  "myaccount_billing_details_description": "Измените данные аккаунта и платежный адрес.",
  "myaccount_billing_details_details": "Платежные реквизиты",
  "myaccount_billing_details_email": "Адрес эл. почты",
  "myaccount_billing_details_fistname": "Имя",
  "myaccount_billing_details_lastname": "Фамилия",
  "myaccount_billing_details_marketing": "Я хочу получать специальные предложения и советы от turboSMTP",
  "myaccount_billing_details_phone_number": "Номер телефона",
  "myaccount_billing_details_policy": "Я прочитал(-а) и согласен(-на) с Политикой конфиденциальности и Условиями использования",
  "myaccount_billing_details_state": "Регион/область",
  "myaccount_billing_details_zip": "Индекс",
  "myaccount_billing_slides_description": "Здесь вы найдете «Счета-проформы», связанные с вашим аккаунтом.",
  "myaccount_billing_cancellation_select_reason": "Выберите причину",
  "myaccount_billing_slides_nodata": "Счета-проформы не найдены",
  "myaccount_billingcontacts_added": "Платежный контакт успешно добавлен",
  "myaccount_billingcontacts_deleted": "Платежный контакт успешно удален",
  "myaccount_billingcontacts_edited": "Платежный контакт успешно изменен",
  "myaccount_billingdetails_updated": "Платежные реквизиты обновлены",
  "myaccount_change_password": "Изменить пароль",
  "myaccount_confirm_delete_selectedcontact_label": "Подтвердите действие",
  "myaccount_confirm_delete_selectedcontact_text": "Вы действительно хотите удалить этот контакт?",
  "myaccount_confirm_password": "Подтвердите пароль",
  "myaccount_current_password": "Подтвердить текущий пароль",
  "myaccount_language": "Отображать язык",
  "myaccount_language_change": "Выбрать язык",
  "myaccount_language_description": "TurboSMTP теперь доступен на английском и итальянском языках. (Французский, немецкий, иврит, португальский, русский, арабский и испанский скоро появятся.)",
  "myaccount_language_select": "Выберите язык",
  "myaccount_messages": "Системные сообщения",
  "myaccount_messages_nomessages_description": "В этом разделе вы найдёте сообщения, которые наша система отправила на ваш аккаунт.",
  "myaccount_new_password": "Новый пароль",
  "myaccount_password_changed": "Ваш пароль успешно изменен",
  "myaccount_password_choose": "Выберите новый пароль",
  "myaccount_password_notmatch": "Пароли не совпадают. Попробуйте ещё раз.",
  "myaccount_password_suggestions": "Пароли должны содержать не менее 10 символов, в том числе заглавные и строчные буквы и хотя бы одну цифру.",
  "myaccount_product_delete_label": "Подтвердите действие",
  "myaccount_product_delete_text": "Вы уверены, что хотите отменить этот продукт?",
  "myaccount_products": "Мои продукты",
  "myaccount_products_billingcycle": "Платежный цикл",
  "myaccount_products_cycle_annually": "Ежегодно",
  "myaccount_products_cycle_biennally": "Раз в два года",
  "myaccount_products_cycle_free_account": "Бесплатный аккаунт",
  "myaccount_products_cycle_month": "Ежемесячно",
  "myaccount_products_cycle_monthly": "Ежемесячно",
  "myaccount_products_cycle_one_time": "Один раз",
  "myaccount_products_cycle_onetime": "Один раз",
  "myaccount_products_cycle_quarterly": "Раз в квартал",
  "myaccount_products_cycle_semi-annually": "Раз в полгода",
  "myaccount_products_cycle_triennially": "Раз в три года",
  "myaccount_products_cycle_year": "Ежегодно",
  "myaccount_products_cycle_yearly": "Ежегодно",
  "myaccount_products_fistpayment": "Сумма первого платежа",
  "myaccount_products_nextduedate": "Дата следующего платежа",
  "myaccount_products_noproduct_description": "В этом разделе вы найдёте продукты и услуги, связанные с аккаунтом.",
  "myaccount_products_payment": "Способ оплаты",
  "myaccount_products_price": "Цена",
  "myaccount_products_productservice": "Продукты/услуги",
  "myaccount_products_recurringamount": "Повторяющийся платеж",
  "myaccount_products_registration": "Дата регистрации",
  "myaccount_products_slide_productservice_description": "Управляйте своим продуктом прямо из этой области.",
  "myaccount_products_status": "Статус",
  "plans_addon_options_title": "Дополнительные планы",
  "plans_available_recurring_options_title": "Доступные планы",
  "plans_billing_cycle": "Цикл выставления счетов",
  "plans_current_plans_title": "Ваши текущие планы",
  "plans_cycle_month": "Ежемесячно",
  "plans_cycle_monthly": "Ежемесячно",
  "plans_cycle_onetime": "Разовый",
  "plans_cycle_year": "Ежегодно",
  "plans_cycle_yearly": "Ежегодно",
  "plans_downgrade_options_title": "Варианты понижения",
  "plans_feature_dedicated_ip": "Выделенный IP",
  "plans_feature_email_credits": "Кредиты email",
  "plans_feature_smtp_limit": "Лимит SMTP",
  "plans_features": "Характеристики",
  "plans_invoice_created": "Счёт успешно создан.",
  "plans_invoice_error": "Не удалось создать счёт. Попробуйте ещё раз.",
  "plans_load_error": "Не удалось загрузить варианты плана. Попробуйте ещё раз.",
  "plans_onetime_options_title": "Разовые планы",
  "plans_plan_name": "Название плана",
  "plans_plan_type": "Тип плана",
  "plans_select_plan": "Выбрать план",
  "plans_type_addon": "Дополнение",
  "plans_type_onetime": "Разовый",
  "plans_type_recurring": "Регулярный",
  "plans_upgrade_options_title": "Варианты повышения",
  "myaccount_sentdate": "Дата отправки",
  "new_dashboard_error": "К сожалению, произошла ошибка.",
  "new_dashboard_if_you_think": "Если вы считаете, что видите это сообщение по ошибке, <a href=\"https://serversmtp.com/ru/ru_contacts/\" target=\"_blank\" >свяжитесь с нами</a>.",
  "new_dashboard_not_allowed": "Свяжитесь с нашей <a href='https://serversmtp.com/ru/ru_contacts/' target='_blank'>службой поддержки</a>, чтобы начать использовать бета-версию Dashboard.",
  "new_dashboard_token_valid": "Токен действителен",
  "new_dashboard_token_wrong": "Токен неверен",
  "new_dashboard_validating": "Проверка токена...",
  "no": "Нет",
  "no_parameters_was_provided_for_update": "Не указан параметр для обновления",
  "no_suppression_data_were_provided": "Данные о подавлении предоставлены не были",
  "one_time": "Один раз",
  "optional": "Необязательно",
  "or": "или",
  "password_is_invalid": "Ни один аккаунт не соответствует этому паролю",
  "password_is_missing": "Пароль отсутствует",
  "password_length_should_not_be_less_than_10_characters": "Пароль должен быть не менее 10 символов длиной.",
  "password_should_contain_at_least_one_uppercase_character": "Пароль должен содержать не менее 1 заглавной буквы",
  "password_should_contain_at_least_one_lowercase_character": "Пароль должен содержать не менее 1 строчной буквы",
  "password_should_contain_at_least_one_digit": "Пароль должен содержать не менее 1 цифры",
  "password_should_equals_to_confirm_password": "Пароль и подтверждение должны совпадать",
  "plan_daily": "Ежедневный план",
  "plan_monthly": "Ежемесячный план",
  "plan_yearly": "Годовой план",
  "primeng": {
    "accept": "Да",
    "addRule": "Добавить правило",
    "after": "После",
    "apply": "Принять",
    "before": "До",
    "cancel": "Отмена",
    "choose": "Выберите",
    "clear": "Очистить",
    "contains": "Содержит",
    "dateAfter": "Дата после",
    "dateBefore": "Дата до",
    "dateFormat": "dd.mm.yyyy",
    "dateIs": "Дата равна",
    "dateIsNot": "Дата не равна",
    "dayNames": [
      "Воскресенье",
      "Понедельник",
      "Вторник",
      "Среда",
      "Четверг",
      "Пятница",
      "Суббота"
    ],
    "dayNamesMin": [
      "Вс",
      "Пн",
      "Вт",
      "Ср",
      "Чт",
      "Пт",
      "Сб"
    ],
    "dayNamesShort": [
      "Вск",
      "Пнд",
      "Втр",
      "Срд",
      "Чтв",
      "Птн",
      "Сбт"
    ],
    "emptyFilterMessage": "Результатов не найдено",
    "emptyMessage": "Нет доступных вариантов",
    "endsWith": "Заканчивается",
    "equals": "Равно",
    "firstDayOfWeek": 1,
    "gt": "Более чем",
    "gte": "Более чем или равно",
    "is": "является",
    "isNot": "не является",
    "lt": "Меньше чем",
    "lte": "Меньше чем или равно",
    "max_limit_reached": "Вы достигли максимального количества субаккаунтов, которые можно активировать на вашем текущем тарифе.",
    "matchAll": "Сопоставить все",
    "matchAny": "Совпадение с любым",
    "medium": "Нормальный",
    "monthNames": [
      "Январь",
      "Февраль",
      "Март",
      "Апрель",
      "Май",
      "Июнь",
      "Июль",
      "Август",
      "Сентябрь",
      "Октябрь",
      "Ноябрь",
      "Декабрь"
    ],
    "monthNamesShort": [
      "Янв",
      "Фев",
      "Мар",
      "Апр",
      "Май",
      "Июн",
      "Июл",
      "Авн",
      "Сен",
      "Окт",
      "Ноя",
      "Дек"
    ],
    "noFilter": "Нет фильтра",
    "notContains": "Не содержит",
    "notEquals": "Не равно",
    "passwordPrompt": "Введите пароль",
    "reject": "Нет",
    "removeRule": "Удалить правило",
    "startsWith": "Начинается с",
    "strong": "Хороший",
    "today": "Сегодня",
    "upload": "Загрузить",
    "weak": "Простой",
    "weekHeader": "Нед."
  },
  "saturday": "Суббота",
  "server_error_please_try_again": "Ошибка сервера. Попробуйте еще раз позже.",
  "server_error_while_performing_update": "При обновлении произошла ошибка сервера",
  "server_problem_gateway_timeout": "Тайм-аут шлюза сервера, повторите попытку.",
  "server_problem_please_retry": "Проблема с сервером, повторите попытку.",
  "server_problem_unknown_error": "Неизвестная ошибка сервера. Повторите попытку.",
  "settings_activities_description": "Получайте отчеты об активности аккаунта на свой почтовый ящик. Отчеты могут быть ежедневными, еженедельными и/или ежемесячными и охватывать все действия в вашем аккаунте.",
  "settings_activities_slide_dailyreport": "Ежедневный отчет",
  "settings_activities_slide_day": "День",
  "settings_activities_slide_dayoftheweek": "День недели",
  "settings_activities_slide_description": "Вы можете получать ежедневные, еженедельные и ежемесячные отчеты обо всех действиях в своем аккаунте. Отчет будет отправлен на зарегистрированный адрес электронной почты.",
  "settings_activities_slide_monthlyreport": "Ежемесячный отчет",
  "settings_activities_slide_time": "Время",
  "settings_activities_slide_title": "Отчеты о деятельности",
  "settings_activities_slide_weeklyreport": "Еженедельный отчет",
  "settings_activities_title": "Отчеты о деятельности",
  "settings_alert_usage_limit": "Лимит использования",
  "settings_alerts_description": "Получайте уведомление письмом, когда используете определенный процент кредитов электронной почты.",
  "settings_alerts_slide_add": "Добавить уведомление",
  "settings_alerts_slide_description": "Чтобы избежать нехватки реле в середине рассылки, получайте оповещения по электронной почте, когда исчерпан определенный процент кредитов. Рекомендуем активировать оповещение при 80% доступного кредита.",
  "settings_alerts_slide_empty_description": "Установите оповещение, которое придет на ваш адрес электронной почты, когда вы исчерпаете определенный процент кредитов.",
  "settings_alerts_slide_empty_title": "Добавить уведомление",
  "settings_alerts_slide_frequency": "Частота",
  "settings_alerts_slide_percentage": "Показатель в процентах",
  "settings_alerts_slide_placeholder": "например, имя@адрес.com",
  "settings_alerts_slide_sendto": "Отправить",
  "settings_alerts_slide_title": "Оповещения",
  "settings_alerts_slide_type": "Тип оповещения",
  "settings_alerts_title": "Оповещения",
  "settings_api_description": "Отправляйте электронные письма прямо со своего веб-сайта или из приложения с помощью API turboSMTP.",
  "settings_api_title": "Документация по API",
  "settings_bccs_description": "Каждый адрес электронной почты в списке BCC получит копию каждого электронного письма, при этом получатель не увидит сведения о других получателях.",
  "settings_bccs_enable": "Включить авторизацию одной или нескольких учетных записей электронной почты для получения копии любых отправленных писем.",
  "settings_bccs_slide_add": "Добавить скрытую копию",
  "settings_bccs_slide_description": "Настройте и авторизуйте одну или несколько учетных записей электронной почты, чтобы получать копии любых электронных писем.",
  "settings_bccs_slide_email": "Адрес электронной почты",
  "settings_bccs_slide_empty": "Настройте одну учетную запись электронной почты и авторизуйте ее для получения копии любых электронных писем.",
  "settings_bccs_slide_empty_title": "Добавить адрес в скрытую копию",
  "settings_bccs_slide_name": "Имя",
  "settings_bccs_slide_not_verified": "Не подтвержденный",
  "settings_bccs_slide_status": "Статус",
  "settings_bccs_slide_title": "Скрытая копия (BCC)",
  "settings_bccs_slide_verified": "Подтвержденный",
  "settings_bccs_title": "Скрытая копия (BCC)",
  "settings_bounces_description": "Функция «Уведомление об отказах» отправляет нам оповещения о вернувшихся письмах. Отключите ее, чтобы оповещения приходили к вам.",
  "settings_bounces_title": "Управление отказами",
  "settings_click_tracking": "Отслеживание кликов",
  "settings_click_tracking_description": "«Отслеживание кликов» записывает все нажатия на каждую ссылку в ваших электронных письмах.",
  "settings_dns_bar_description": "SPF- и DKIM-записи должны быть добавлены ко всем доменам адресов электронной почты отправителя.",
  "settings_dns_bar_dkim_description": "DKIM-запись можно добавить как TXT-запись, вставив следующее:",
  "settings_dns_bar_dkim_title": "DKIM-записи",
  "settings_dns_bar_domainaut": "Аутентификацию домена",
  "settings_dns_bar_domainaut_description": "Разрешите TurboSMTP отправлять электронные письма от вашего имени.",
  "settings_dns_bar_spf_description": "Добавьте следующую TXT-запись в домен адреса конверта (example.com) в одном из следующих двух случаев:",
  "settings_dns_bar_spf_description_a": "<strong>Если запись SPF уже существует в настройках DNS вашего домена</strong>, вам нужно будет изменить ее. Просто вставьте",
  "settings_dns_bar_spf_description_b": "непосредственно после сегмента",
  "settings_dns_bar_spf_description_c": "Не забудьте оставить пробел до и после этого добавления, чтобы сохранить правильный синтаксис.",
  "settings_dns_bar_spf_description_d": "<strong>При отсутствии существующего SPF</strong> приступайте к его созданию, введя необходимую информацию в новую запись TXT в настройках DNS (нет необходимости указывать домен SPF, если это не требуется):",
  "settings_dns_bar_spf_title": "SPF-запись",
  "settings_dns_bar_title": "Настройки DNS",
  "settings_dns_description": "Добавьте наши DNS-записи в свой домен, чтобы подписывать электронные письма с помощью DKIM и обеспечивать оптимальную пропускную способность.",
  "settings_dns_title": "DNS-записи",
  "settings_email_body_tip": "Пожалуйста, укажите <% body %> при вводе.",
  "settings_email_elements": "Элементы электронной почты",
  "settings_email_footers_added": "Нижний колонтитул успешно добавлен",
  "settings_email_footers_confirm_delete_label": "Подтвердите действие",
  "settings_email_footers_confirm_delete_text": "Хотите удалить этот колонтитул?",
  "settings_email_footers_default": "Настройки успешно обновлены",
  "settings_email_footers_removed": "Нижний колонтитул успешно удален",
  "settings_email_footers_updated": "Нижний колонтитул успешно обновлен",
  "settings_email_name_tip": "Укажите имя",
  "settings_email_templates_added": "Шаблон успешно добавлен",
  "settings_email_templates_confirm_delete_label": "Подтвердите действие",
  "settings_email_templates_confirm_delete_text": "Вы хотите удалить этот шаблон?",
  "settings_email_templates_default": "Настройки шаблона успешно обновлены",
  "settings_email_templates_removed": "Шаблон успешно удален",
  "settings_email_templates_updated": "Шаблон успешно обновлен",
  "settings_email_unsub_added": "Ссылка «Отписаться» успешно добавлена",
  "settings_email_unsub_confirm_delete_label": "Подтвердите действие",
  "settings_email_unsub_confirm_delete_text": "Вы действительно хотите удалить эту ссылку «Отписаться»?",
  "settings_email_unsub_removed": "Ссылка «Отписаться» успешно удалена",
  "settings_email_unsub_updated": "Ссылка «Отписаться» успешно обновлена",
  "settings_footers_description": "Добавьте нижний колонтитул к электронным письмам.",
  "settings_footers_slide_add": "Добавить нижний колонтитул",
  "settings_footers_slide_convert": "HTML в текст",
  "settings_footers_slide_default": "По умолчанию",
  "settings_footers_slide_description": "Нажмите «Добавить нижний колонтитул» или отредактируйте существующий, затем введите название нижнего колонтитула и заполните поля, используя HTML или обычный текст.",
  "settings_footers_slide_empty_description": "Нажмите «Добавить нижний колонтитул» или отредактируйте существующий, затем введите название нижнего колонтитула и заполните поля, используя HTML или обычный текст.",
  "settings_footers_slide_empty_title": "Нижних колонтитулов нет",
  "settings_footers_slide_htmltext": "HTML-текст",
  "settings_footers_slide_name": "Название",
  "settings_footers_slide_plaintext": "Простой текст",
  "settings_footers_slide_title": "Нижние колонтитулы",
  "settings_footers_title": "Нижние колонтитулы",
  "settings_ga_bar_description": "Пожалуйста, заполните следующие поля, включая название и источник данных вашей кампании, чтобы активировать интеграцию с Google Аналитикой.",
  "settings_ga_bar_title": "Google Аналитика",
  "settings_ga_content": "Содержание кампании",
  "settings_ga_content_mandatory": "Содержание кампании обязательно",
  "settings_ga_integrate": "Интегрируйте Google Аналитику, чтобы отслеживать коэффициенты конверсии и другие данные.",
  "settings_ga_medium": "Канал проведения кампании",
  "settings_ga_medium_mandatory": "Канал кампании является обязательным",
  "settings_ga_name": "Название кампании",
  "settings_ga_name_mandatory": "Название кампании обязательно",
  "settings_ga_parameters": "Параметры",
  "settings_ga_parameters_description": "Пожалуйста, заполните следующие поля, включая название и источник данных вашей кампании, чтобы активировать интеграцию с Google Аналитикой.",
  "settings_ga_source": "Источник кампании",
  "settings_ga_source_mandatory": "Источник кампании обязателен.",
  "settings_ga_term": "Сроки кампании",
  "settings_ga_term_mandatory": "Сроки кампании обязательны",
  "settings_google_analytics_description": "Google Аналитика отслеживает ваши коэффициенты конверсии и другие данные.",
  "settings_google_analytics_title": "Google Аналитика",
  "settings_integrations": "Интеграции",
  "settings_integrations_dkim_updated": "Настройки DKIM успешно обновлены",
  "settings_notification_alert_confirm_delete_label": "Подтвердите действие",
  "settings_notification_alert_confirm_delete_text": "Вы хотите удалить это оповещение?",
  "settings_notification_bcc_confirm_delete_label": "Подтвердите действие",
  "settings_notification_bcc_confirm_delete_success": "Скрытая копия {email} успешно удалена.",
  "settings_notification_bcc_confirm_delete_text": "Вы действительно хотите удалить эту скрытую копию {email}?",
  "settings_notification_smtp_auth": "SMTP-аутентификация",
  "settings_notifications": "Уведомления",
  "settings_notifications_alert_added": "Оповещение успешно создано",
  "settings_notifications_alert_deleted": "Оповещение успешно удалено.",
  "settings_notifications_alert_updated": "Оповещение успешно обновлено",
  "settings_notifications_bcc_emailbox": "Мы только что отправили сообщение с подтверждением на адрес <{email}>.",
  "settings_notifications_bcc_update_success": "Скрытая копия {email} успешно обновлена.",
  "settings_notifications_smtp_auth_enabled": "Включено",
  "settings_notifications_smtp_host": "pro.turbo-smtp.com",
  "settings_notifications_smtp_host_eu": "pro.eu.turbo-smtp.com",
  "settings_notifications_smtp_passvalue": "*********<br>(пароль, который вы указали при регистрации)",
  "settings_notifications_smtp_password": "Пароль SMTP",
  "settings_notifications_smtp_ports": "SMTP-порты",
  "settings_notifications_smtp_server": "SMTP-сервер",
  "settings_notifications_smtp_username": "Имя пользователя SMTP",
  "settings_open_tracking": "Открытое отслеживание",
  "settings_open_tracking_description": "Включенная функция «Открытое отслеживание» создает запись открытых сообщений, благодаря которой вам будет проще отслеживать результаты кампании.",
  "settings_setting_changed": "Настройка изменена: {service}",
  "settings_setting_disabled": "Настройка отключена: {service}",
  "settings_setting_enabled": "Настройка включена: {service}",
  "settings_setting_notdisabled": "Настройка {service} не может быть включена.",
  "settings_setting_notenabled": "Настройка {service} не может быть включена.",
  "settings_setting_webhook_notenabled": "Веб-перехватчики уведомлений о событиях доступны только в повторяющихся планах PRO.",
  "settings_smtp_description": "Чтобы подключиться через SMTP, настройте SMTP в почтовом клиенте или любом другом почтовом приложении, добавив указанные ниже параметры. Для просмотра параметров нажмите кнопку «Дополнительно».",
  "settings_smtp_slide_description": "Настройте SMTP в почтовом клиенте или любом другом почтовом приложении, добавив указанные ниже параметры.",
  "settings_smtp_slide_description_api": "Имя пользователя и пароль для аутентификации SMTP — это пара API-ключей: используйте Consumer Key в качестве имени пользователя SMTP и Consumer Secret в качестве пароля SMTP. Рассматривайте их как учётные данные, которые нужно хранить в секрете и при необходимости менять.",
  "settings_smtp_slide_parameter": "Параметр",
  "settings_smtp_slide_title": "Подключение через SMTP",
  "settings_smtp_slide_value": "Значение",
  "settings_smtp_title": "Подключение через SMTP",
  "settings_template_description": "Шаблоны — это идеальный инструмент, позволяющий без труда структурировать электронное письмо и повысить его эффективность.",
  "settings_template_slide_add": "Добавить шаблон",
  "settings_template_slide_default": "По умолчанию",
  "settings_template_slide_description": "Нажмите «Добавить шаблон» и заполните поля необходимой информацией, включая имя шаблона и HTML- или обычный текст.",
  "settings_template_slide_empty_description": "Нажмите «Добавить шаблон» и заполните поля необходимой информацией, включая имя шаблона и HTML- или обычный текст.",
  "settings_template_slide_empty_title": "Добавить шаблон",
  "settings_template_slide_html": "HTML-версия",
  "settings_template_slide_info": "<% body %> является обязательным в HTML- и обычном тексте. Подсказку заменит реальное содержание.",
  "settings_template_slide_name": "Название шаблона",
  "settings_template_slide_plaintext": "Простой текст",
  "settings_template_slide_title": "Шаблоны",
  "settings_template_title": "Шаблоны",
  "settings_title": "Настройки",
  "settings_tracking": "Отслеживание",
  "settings_unsubscribe_description": "Добавьте ссылку для отказа от подписки в нижней части текстовых и HTML-сообщений электронной почты. Пользователи, отказавшиеся от рассылки, не получат никаких электронных писем.",
  "settings_unsubscribe_select": "Выбрать язык",
  "settings_unsubscribe_slide_add": "Добавить ссылку «Отписаться»",
  "settings_unsubscribe_slide_description": "Добавьте ссылку для отказа от подписки в нижней части текстовых и HTML-сообщений электронной почты. Пользователи, отказавшиеся от рассылки, не получат никаких электронных писем. Отмена подписки будет обрабатываться автоматически и в режиме реального времени, чтобы улучшить репутацию вашей рассылки. Введите текст, который хотите использовать (например, «Чтобы отказаться от подписки, нажмите здесь»), а затем вставьте текст вместо подсказки в своем письме.",
  "settings_unsubscribe_slide_empty": "Добавить ссылку «Отписаться»",
  "settings_unsubscribe_slide_empty_description": "Добавьте ссылку для отказа от подписки в нижней части текстовых и HTML-сообщений электронной почты. Пользователи, отказавшиеся от рассылки, не получат никаких электронных писем. Отмена подписки будет обрабатываться автоматически и в режиме реального времени, чтобы улучшить репутацию вашей рассылки.",
  "settings_unsubscribe_slide_language": "Выбрать язык",
  "settings_unsubscribe_slide_placeholder": "Подсказка",
  "settings_unsubscribe_slide_text": "Текст отказа от подписки",
  "settings_unsubscribe_slide_title": "Ссылка для отказа от подписки",
  "settings_unsubscribe_text": "Текст",
  "settings_unsubscribe_title": "Ссылка для отказа от подписки",
  "settings_unsubscribe_value": "Например: «Чтобы отказаться от подписки, нажмите здесь»",
  "settings_webhooks_description": "Вебхуки позволяют вашему веб-приложению получать уведомления о событиях, связанных с доставкой электронной почты и взаимодействием.",
  "settings_webhooks_slide_bounced": "Отказы",
  "settings_webhooks_slide_click": "Клик",
  "settings_webhooks_slide_deferred": "Отложено",
  "settings_webhooks_slide_delivered": "Доставлено",
  "settings_webhooks_slide_deliveryevents": "События доставки",
  "settings_webhooks_slide_description": "С помощью вебхуков вы можете узнавать о событиях, которые происходят в вашем почтовом проекте, без использования API.",
  "settings_webhooks_slide_dropped": "Сброс",
  "settings_webhooks_slide_engagementevents": "Стимулирующие мероприятия",
  "settings_webhooks_slide_inserturl": "Вставьте здесь URL-адрес для уведомлений",
  "settings_webhooks_slide_notification": "URL-адрес вебхука для уведомлений",
  "settings_webhooks_slide_notification_description": "Включить уведомления для вебхука",
  "settings_webhooks_slide_open": "Открыт",
  "settings_webhooks_slide_placeholder": "https://",
  "settings_webhooks_slide_processed": "В обработке",
  "settings_webhooks_slide_spamreport": "Отчет о спаме",
  "settings_webhooks_slide_title": "Вебхуки",
  "settings_webhooks_slide_unsubscribe": "Отмена подписки",
  "settings_webhooks_support": "Обратитесь в службу поддержки и попросите «Активацию событий доставки».",
  "settings_webhooks_title": "Вебхуки",
  "settings_webhooks_upgrade": "Обновитесь до PRO",
  "subaccount_policy_agree": "Я прочитал(-а) и согласен(-на) с <a href=\"https://serversmtp.com/ru/ru_terms-and-conditions/\" target=\"_blank\">условиями обслуживания</a> и <a href=\"https://serversmtp.com/privacypolicy-eu-regulation-2016-79-gdpr/\" target=\"_blank\">политикой конфиденциальности</a>",
  "subaccount_policy_agree_notchecked": "Вы должны выразить согласие с Условиями использования и Политикой конфиденциальности",
  "subaccount_slide_inuse": "При использовании",
  "subaccount_slide_ip": "IP",
  "subaccount_slide_ips": "IP-адреса",
  "subaccount_slide_ips_description": "Пожалуйста, выберите IP, который будет назначен для этого субаккаунта.",
  "subaccounts_action_activated": "адрес {email} успешно активирован",
  "subaccounts_action_active": "Активный",
  "subaccounts_action_deactivated": "Адрес {email} успешно заблокирован",
  "subaccounts_action_delete": "Удалить",
  "subaccounts_action_deleted": "Субаккаунт успешно удален",
  "subaccounts_action_details": "Данные",
  "subaccounts_action_edit": "Редактировать",
  "subaccounts_action_limit": "Установить лимиты",
  "subaccounts_action_login": "Войти",
  "subaccounts_action_notdeleted": "Ошибка удаления субаккаунта",
  "subaccounts_action_suspend": "Приостановить",
  "subaccounts_active": "Активный",
  "subaccounts_added_succesfully": "Субаккаунт успешно добавлен",
  "subaccounts_agencysettings": "Настройки агентства",
  "subaccounts_assigned_ip": "Назначенный IP",
  "subaccounts_changed_succesfully": "Субаккаунт успешно изменен",
  "subaccounts_confirm_activation_label": "Подтвердить активацию",
  "subaccounts_confirm_activation_text": "Вы хотите активировать {email}?",
  "subaccounts_confirm_deactivation_label": "Подтвердить деактивацию",
  "subaccounts_confirm_deactivation_text": "Вы хотите приостановить действие субаккаунта: {email}?",
  "subaccounts_confirm_delete_label": "Подтвердить удаление",
  "subaccounts_confirm_delete_text": "Вы хотите удалить субаккаунт {email}?",
  "subaccounts_confirm_login_label": "Подтвердить вход",
  "subaccounts_confirm_login_text": "Вы уверены, что хотите выйти из текущей учетной записи и войти в {email}?",
  "subaccounts_confirmation": "Подтверждение",
  "subaccounts_create_warning": "Создание новых субаккаунтов доступно только для подписок Professional.",
  "subaccounts_email": "Электронная почта в аккаунте",
  "subaccounts_empty": "Расширьте свой бизнес и предложите своим клиентам профессиональные услуги, полностью настраиваемые под ваш бренд, или разделите электронную почту между вашими сотрудниками и коллегами.<br>Простой интерфейс управления позволит вам отслеживать трафик и статистику.",
  "subaccounts_expiration_date": "Окончание срока действия",
  "subaccounts_inactive": "Неактивно",
  "subaccounts_ip": "IP",
  "subaccounts_last_activity": "Последняя операция",
  "subaccounts_limits_nolimits": "Без ограничений",
  "subaccounts_limits_sending": "Лимит отправки:",
  "subaccounts_limits_slide_description": "Установите лимит для вашего субаккаунта.",
  "subaccounts_limits_slide_limits": "Лимиты",
  "subaccounts_limits_slide_noplan_expiration": "Бессрочно",
  "subaccounts_limits_slide_plan_expiration": "Срок действия плана",
  "subaccounts_limits_slide_set_plan_expiration": "Установить срок действия плана",
  "subaccounts_limits_slide_this_number": "Это число относится к периоду",
  "subaccounts_limits_slide_title": "Лимиты для субаккаунта",
  "subaccounts_no_expiration": "({master_expiration_date}) <i class=\"pi pi-info-circle\"></i>",
  "subaccounts_no_expiration_tooltip": "В соответствии со сроком действия плана для основного аккаунта",
  "subaccounts_settings_update": "Настройки аккаунта обновляются.",
  "subaccounts_slide_account_confirm": "Подтвердить данные аккаунта",
  "subaccounts_slide_account_description": "Нажмите кнопку «Изменить», чтобы отредактировать информацию о пользователе вашего субаккаунта.",
  "subaccounts_slide_account_info": "Данные аккаунта",
  "subaccounts_slide_address": "Адрес",
  "subaccounts_slide_address2": "Адрес №2",
  "subaccounts_slide_change_password": "Задать пароль",
  "subaccounts_slide_city": "Город",
  "subaccounts_slide_company": "Название компании",
  "subaccounts_slide_confirm_password": "Подтвердите пароль",
  "subaccounts_slide_confirmpassword_different": "Убедитесь, что ваши пароли совпадают.",
  "subaccounts_slide_country": "Страна",
  "subaccounts_slide_email": "Адрес эл. почты",
  "subaccounts_slide_email_not_unique": "Этот адрес уже используется.",
  "subaccounts_slide_email_required": "Адрес электронной почты обязателен.",
  "subaccounts_slide_first_name": "Имя",
  "subaccounts_slide_firstname_required": "Требуется указать имя.",
  "subaccounts_slide_last_name": "Фамилия",
  "subaccounts_slide_lastname_required": "Требуется указать фамилию.",
  "subaccounts_slide_password": "Пароль",
  "subaccounts_slide_password_details": "Оставьте поле пароля пустым, чтобы использовать текущий пароль.",
  "subaccounts_slide_password_minlength": "Длина пароля должна быть не менее {req}. В настоящее время: {act}.",
  "subaccounts_slide_password_required": "Требуется пароль.",
  "subaccounts_slide_password_pattern": "Пароль должен содержать не менее 10 символов, из которых не менее одной заглавной, одной строчной и одной цифры",
  "subaccounts_slide_phone": "Телефон",
  "subaccounts_slide_profile_information": "Данные профиля",
  "subaccounts_slide_region": "Штат/регион/провинция",
  "subaccounts_slide_website": "Веб-сайт",
  "subaccounts_slide_zip": "Индекс",
  "subaccounts_status": "Статус",
  "subaccounts_subaccounts": "Список субаккаунтов",
  "subaccounts_title": "Субаккаунты",
  "subaccounts_unlimited": "Без ограничений <i class='pi pi-info-circle'></i>",
  "subaccounts_unlimited_tooltip": "В соответствии с лимитом плана основного аккаунта.",
  "subaccounts_usage": "Использование",
  "sunday": "Воскресенье",
  "suppression_deleted": "Подавление будет удалено в ближайшее время.",
  "suppression_filters_reason": "Причина",
  "suppression_filters_recipient": "Получатель",
  "suppression_filters_sender": "Отправитель",
  "suppression_filters_sources": "Источники",
  "suppression_filters_subject": "Тема письма",
  "suppression_operators_exclude": "Исключить",
  "suppression_operators_include": "Включить",
  "suppression_table_addcolumn_sender": "Отправитель",
  "suppression_table_dropdown_text": "{first} по {last} из {totalRecords}",
  "suppression_types_bounce": "Отказы",
  "suppression_types_manual": "Ручные",
  "suppression_types_spam": "Спам",
  "suppression_types_unsubscribe": "Отписавшиеся",
  "suppression_types_validation_failed": "Не удалось выполнить проверку",
  "suppressions_add_form_errors": "Ошибки формы",
  "suppressions_add_form_nofile_selected": "Файл не выбран",
  "suppressions_add_suppression": "Импортировать подавления",
  "suppressions_choose_columns": "Выберите столбцы",
  "suppressions_confirm_delete_all_label": "Подтвердите действие",
  "suppressions_confirm_delete_all_text": "Вы действительно хотите удалить все подавления между <strong>{from}</strong> и <strong>{to}</strong>?",
  "suppressions_confirm_delete_all_type_text": "Вы действительно хотите подавить<br> все подавления <strong>{type}</strong> между <strong>{from}</strong> и <strong>{to}</strong>?",
  "suppressions_confirm_delete_filtered_label": "Подтвердите действие",
  "suppressions_confirm_delete_filtered_text": "Вы действительно хотите удалить все <strong>отфильтрованные подавления</strong>? <br><small>* Спам-сообщения не удаляются.</small>",
  "suppressions_confirm_delete_selected_label": "Подтвердите действие",
  "suppressions_confirm_delete_selected_text": "Вы действительно хотите удалить выбранные подавления?",
  "suppressions_date": "Дата",
  "suppressions_delete_all": "Удалить все",
  "suppressions_delete_selected": "Удалить подборку",
  "suppressions_deleted": "Подавление будет удалено в ближайшее время.",
  "suppressions_description_empty": "За выбранный период записей не найдено.",
  "suppressions_details_date": "Дата",
  "suppressions_details_entry": "Запись",
  "suppressions_details_reason": "Причина",
  "suppressions_details_sender": "Отправитель",
  "suppressions_details_subject": "Тема",
  "suppressions_details_title": "Данные",
  "suppressions_details_type": "Тип",
  "suppressions_imported": "Ваши подавления скоро будут импортированы.",
  "suppressions_imported_partial": "{imported} из {total} подавлений вскоре будет импортировано.",
  "suppressions_include": "Включить",
  "suppressions_modal_confirm": "Подтверждение",
  "suppressions_not_imported": "Подавление не будет импортировано из-за искаженного формата электронной почты.",
  "suppressions_reason": "Причина",
  "suppressions_recipient": "Получатель",
  "suppressions_title": "Подавления",
  "suppressions_title_empty": "Подавление не найдено",
  "suppressions_type": "Тип",
  "t_api": "Документация по API",
  "t_knowledgebase": "База знаний",
  "t_logout": "Выход из системы",
  "table_dropdown_goto": "Перейти на страницу",
  "table_dropdown_text": "с {first} по {last} из {totalRecords}",
  "thursday": "Четверг",
  "toggle_off": "Выключено",
  "toggle_on": "Включено",
  "token_can_not_be_empty": "Токен не может быть пустым",
  "token_is_missing": "Токен отсутствует",
  "tuesday": "Вторник",
  "unlimited": "неограниченный",
  "upload_add_manually": "Добавить вручную",
  "upload_add_manually_description": "Скопируйте и вставьте несколько адресов электронной почты в область ниже, разделив их концевой чертой. Чтобы помнить, почему вы добавили контакты, и облегчить будущие поиски, добавьте причину скрытия этих адресов.",
  "upload_add_reason": "Введите причину блокировки этих адресов.",
  "upload_allowed_files": "Допустимые форматы файлов: csv и txt.",
  "upload_dd_here": "Перетащите файл сюда.",
  "upload_import_from_file": "Импорт из CSV-файла",
  "upload_import_from_file_description": "Файл должен состоять из одного столбца, содержащего все адреса электронной почты, которые вы хотите импортировать. Чтобы помнить, почему вы добавили контакты, и облегчить будущие поиски, добавьте причину скрытия этих адресов.",
  "warning_lang": "Панель управления на вашем языке скоро появится. А пока обратитесь в службу поддержки, чтобы вернуться к старому.",
  "wednesday": "Среда",
  "whitelabel_agencyname": "Название агентства",
  "whitelabel_companydetails": "Реквизиты компании",
  "whitelabel_description": "Если вы открыли субаккаунт и являетесь официальным реселлером turboSMTP, персонализация продукта с помощью вашего логотипа и информации о компании даст клиентам возможность познакомиться с вашим брендом.",
  "whitelabel_footer": "Нижний колонтитул агентства",
  "whitelabel_footer_description": "Вставьте HTML-код, который будет отображаться на странице нижнего колонтитула.",
  "whitelabel_logo": "Логотип компании",
  "whitelabel_logo_description": "Максимально допустимый размер изображения: 472 x 72 пикс.",
  "whitelabel_reset_default_image": "Восстановить изображение по умолчанию",
  "whitelabel_upload_image": "Загрузить изображение",
  "whitelabel_upload_in_progress": "Идет загрузка",
  "whitelabel_website": "Сайт агентства",
  "wrong_credentials_specified": "Указанные учетные данные неверны.",
  "yes": "Да",
  "missing_settings_required": "Некоторые настройки необходимы перед их включением",
  "settings_apikeys_title": "API-ключи",
  "settings_apikeys_description": "Ключи API — это высокобезопасный способ подключения служб turboSMTP к вашим приложениям. Вы можете запретить доступ в любое время.",
  "settings_apikeys_slide_title": "API-ключи",
  "settings_apikeys_slide_description": "Управляйте своими ключами API. В этой таблице показаны все ваши активные ключи API. Вы можете создавать новые ключи или удалять существующие, чтобы отозвать доступ.",
  "settings_apikeys_slide_empty_title": "Создать ключ API",
  "settings_apikeys_slide_empty_description": "Ключи API состоят из ключа пользователя (Consumer Keys) и пароля пользователя (Consumer Secret). Это учетные данные программного обеспечения, которые позволяют программе получить доступ к вашей учетной записи turboSMTP без использования вашего имени пользователя и пароля. Они безопасны и могут быть отозваны в любое время без изменения учетных данных панели управления turboSMTP.",
  "settings_apikeys_slide_add": "Создать ключ API",
  "settings_apikeys_slide_add_description": "Выберите справочное имя для вашего ключа API.",
  "settings_apikeys_apikey_name": "Имя",
  "settings_apikeys_slide_label_info": "Это имя предназначено только для справки. Вам не нужно будет вводить имя в приложениях.",
  "settings_apikeys_apikey_key": "Ключ пользователя",
  "settings_apikeys_apikey_creationtime": "Время создания",
  "settings_apikeys_apikey_name_label": "Имя API-ключа",
  "settings_apikeys_apikey_name_placeholder": "Установите имя ключа API",
  "settings_apikeys_apikey_revoke_alt": "Удалить и отозвать",
  "settings_apikeys_apikey_confirm_revoke_label": "Удалить и отозвать ключ API",
  "settings_apikeys_apikey_confirm_revoke_text": "Удалить ключ API \"{name}\"?<br>Это приведет к аннулированию доступа для всех приложений, использующих этот ключ.",
  "settings_apikeys_apikey_confirm_revoke_confirm": "Подтвердить",
  "settings_apikeys_apikey_confirm_revoke_cancel": "Отмена",
  "settings_apikeys_apikey_revoked": "Ключ API успешно отозван",
  "settings_apikeys_apikey_consumerkey_button_add": "Создать ключ API",
  "settings_apikeys_apikey_new_success": "Ключ API создан!",
  "settings_apikeys_apikey_consumer": "Ключ пользователя",
  "settings_apikeys_apikey_secret": "Пароль пользователя",
  "settings_apikeys_apikey_new_security": "Этот <strong>пароль пользователя (Consumer secret)</strong> отображается только здесь. <strong>Скопируйте его сейчас и сохраните</strong>. Если вы потеряете этот ключ, вам придется удалить его и создать новый.",
  "settings_apikeys_allowed_ips": "Разрешенные IP:",
  "settings_bccs_missing_required": "Пожалуйста, убедитесь, что вы установили один BCC по умолчанию перед его включением",
  "settings_bccs_notifications_default": "Успешно обновлено BCC-электронное письмо по умолчанию",
  "settings_link_branding_enable": "Включить использование собственных доменов отслеживания",
  "settings_link_branding_missing_required": "Добавьте и подтвердите хотя бы один домен перед активацией",
  "settings_link_branding_title": "Пользовательские домены отслеживания",
  "settings_link_branding_description": "Используйте свои собственные домены для отслеживания открытых имейлов и кликов вместо turboSMTP.",
  "settings_link_branding_box_alert": "Эти настройки не вступят в силу, если отключено отслеживание открытых имейлов и кликов.",
  "settings_link_branding_empty_description": "Нажмите «Добавить домен» и заполните поля необходимой информацией...",
  "settings_link_branding_empty_title": "Добавить домен отслеживания",
  "settings_link_branding_add_domain": "Добавить домен отслеживания",
  "settings_link_branding_add_domain_info": "Введите свой домен и измените любые дополнительные настройки.",
  "settings_link_branding_advanced": "Расширенные настройки",
  "settings_link_branding_custom_subdomain": "Пользовательский субдомен",
  "settings_link_branding_custom_subdomain_tooltip": "Пожалуйста, введите действительное доменное имя, прежде чем указывать собственный субдомен.",
  "settings_link_branding_custom_subdomain_info": "Система сгенерирует случайный поддомен. Если вы хотите использовать конкретный, введите его здесь.",
  "settings_link_branding_button_add": "Добавить домен отслеживания",
  "settings_link_branding_match": "Сопоставление домена отслеживания с доменом отправителя",
  "settings_link_branding_match_sender_disabled": "Соответствующие домены отключены",
  "settings_link_branding_match_sender_enabled": "Соответствующие домены включены",
  "settings_link_branding_filters_no_results": "С этими фильтрами записей не найдено",
  "settings_link_branding_search_placeholder": "Фильтровать домены отслеживания по имени...",
  "settings_link_branding_verification_placeholder": "Проверка...",
  "settings_link_branding_verified": "Проверено",
  "settings_link_branding_click_to_verify": "В ОЖИДАНИИ. Конфигурация CNAME для этого домена не завершена и не проверена. Нажмите, чтобы продолжить...",
  "settings_link_branding_verification_success": "Проверка прошла успешно",
  "settings_link_branding_verification_domain_not_found": "Домен не найден",
  "settings_link_branding_verification_cname_not_found": "Субдомен {track_dns} CNAME не найден.",
  "settings_link_branding_verification_auth_cname_not_found": "Субдомен {auth_dns} CNAME не найден.",
  "settings_link_branding_verification_multiple_cname_found": "Обнаружено несколько записей CNAME для субдомена {track_dns}.",
  "settings_link_branding_verification_auth_multiple_cname_found": "Обнаружено несколько записей CNAME для субдомена {auth_dns}.",
  "settings_link_branding_verification_incorrect_cname_target": "CNAME субдомена {track_dns} имеет неправильное значение.",
  "settings_link_branding_verification_auth_incorrect_cname_target": "CNAME субдомена {auth_dns} имеет неправильное значение.",
  "settings_link_branding_enabled": "Включено",
  "settings_link_branding_disabled": "Отключено",
  "settings_link_branding_not_verified": "В ожидании",
  "settings_link_branding_name": "Доменное имя",
  "settings_link_branding_enabled_no": "Отслеживание домена отключено",
  "settings_link_branding_enabled_yes": "Домен отслеживания активен",
  "settings_link_branding_default_enabled": "Домен отслеживания установлен как невыделенный",
  "settings_link_branding_default_disabled": "Домен отслеживания установлен как выделенный",
  "settings_link_branding_subdomain_name_invalid": "Субдомен недействителен",
  "settings_link_branding_domain_name_invalid": "Неверное доменное имя",
  "settings_link_branding_confirm_delete_label": "Удалить домен отслеживания",
  "settings_link_branding_confirm_delete_text": "Вы действительно хотите удалить этот домен отслеживания?",
  "invalid_domain_name": "Указано неверное доменное имя",
  "settings_link_branding_exclusivity_placeholder": "Выделен...",
  "settings_link_branding_exclusive": "Выделен",
  "settings_link_branding_not_exclusive": "Не выделен",
  "settings_link_branding_domain_name": "Домен отслеживания",
  "settings_link_branding_domain_status": "Статус",
  "settings_link_branding_added": "Домен успешно добавлен",
  "settings_link_branding_removed": "Домен успешно удален",
  "settings_link_branding_default_match_help": "Выделенные домены используются только с соответствующим доменом отправителя. Они никогда не используются с несовпадающими доменами.",
  "settings_link_branding_dns_info": "Для завершения процесса вам потребуется установить следующие записи.",
  "settings_link_branding_ssl_verify": "Мы не можем проверить, правильно ли настроены ваши домены SSL с панели управления. Если вам нужна помощь, пожалуйста, свяжитесь с нашей технической службой поддержки.",
  "settings_link_branding_dns_wait": "Изменения в записях DNS вступят в силу в течение 24 часов.",
  "settings_link_branding_dns_info_host": "Добавьте эти две записи в раздел DNS вашего хоста.",
  "settings_link_branding_dns_type": "Тип",
  "settings_link_branding_dns_host": "Хост",
  "settings_link_branding_dns_host_help": "В некоторых DNS-хостингах это может называться «Домен» или «Имя».",
  "settings_link_branding_dns_value": "Значение",
  "settings_link_branding_dns_value_help": "В некоторых DNS-хостингах это может называться «Данные».",
  "settings_link_branding_dns_help": "Не знаете, как это сделать?",
  "settings_link_branding_dns_help_link": "Ознакомьтесь с документацией",
  "settings_link_branding_dns_verification_tooltip": "Эта запись CNAME одинакова для всех поддоменов домена. Её следует добавить только один раз: если она уже присутствует, добавлять её не нужно.",
  "settings_link_branding_verify_description": "После добавления нажмите «Подтвердить».",
  "settings_link_branding_verify_button": "Проверять",
  "settings_link_branding_delete_info": "Этот домен отслеживания больше не нужен?",
  "settings_link_branding_delete_button": "Удалить домен отслеживания",
  "settings_link_branding_security_placeholder": "Безопасность...",
  "settings_link_branding_https": "HTTPS",
  "settings_link_branding_http": "HTTP",
  "settings_link_branding_button_ok": "Подтвердить",
  "settings_link_branding_status_placeholder": "Статус",
  "settings_link_branding_status_enabled_no": "Выключен",
  "settings_link_branding_status_enabled_yes": "Активен",
  "settings_link_branding_all_domains_disabled": "Когда все пользовательские домены отключены или находятся в режиме ожидания, будут использоваться ссылки отслеживания turboSMTP.",
  "settings_link_branding_no_default_domain": "Если вы сделаете все активные ссылки отслеживания выделенными, отправители с отключенными или отсутствующими доменами в этом списке будут вместо этого использовать наши ссылки отслеживания TurboSMTP.",
  "settings_link_branding_match_modal_cancel": "Отмена",
  "settings_link_branding_match_modal_confirm": "Подтвердить",
  "settings_link_branding_match_title": "Ротация доменов",
  "settings_link_branding_match_change": "Изменить этот сценарий",
  "settings_link_branding_match_enabled_title": "Соответствует домену отправителя",
  "settings_link_branding_match_disabled_title": "Не соответствует домену отправителя",
  "settings_link_branding_match_enabled_info": "Если домен отправителя соответствует одному из активных доменов отслеживания, будет использоваться этот домен отслеживания.<br> Если домен отправителя не соответствует ни одному из доменов отслеживания, используется один из активных доменов отслеживания (за исключением \"Выделенных\" доменов) будет использоваться случайным образом.",
  "settings_link_branding_match_disabled_info": "Будут использоваться все активные домены отслеживания, независимо от домена отправителя.",
  "config_server_error": "Приборная панель находится на техническом обслуживании, пожалуйста, повторите попытку через несколько минут",
  "feature_not_available_for_active_plan": "Эта функция не включена ни в один из ваших тарифных планов",
  "forgot_password_use_different_password": "Пожалуйста, создайте новый пароль, который будет отличаться от предыдущих, чтобы повысить безопасность вашей учетной записи.",
  "m_getting_started": "Начало работы",
  "settings_sender_title": "Проверка доменов отправителя",
  "settings_sender_add_domain": "Добавить домен",
  "settings_sender_description": "Чтобы улучшить доставку электронной почты, просто добавьте аутентификацию доменов отправителя с помощью трех ключевых записей DNS.",
  "settings_sender_domains_empty": "Пока нет проверенных доменов отправителя.<br>Пожалуйста, проверьте свой первый домен.",
  "settings_sender_if_unverified": "Что делать, если домен отправителя не проверен?",
  "settings_sender_notify_label": "Уведомить меня по электронной почте, если домен отправителя не проверен",
  "settings_sender_notify_email_label": "Адрес электронной почты",
  "settings_sender_notify_email_tip": "Если пусто, уведомление будет отправлено на адрес учетной записи turboSMTP.",
  "settings_sender_notify_email_error": "Введите действительный адрес электронной почты",
  "settings_sender_notify_email_placeholder": "Введите адрес электронной почты...",
  "settings_sender_dns_title": "Как проверить свой домен",
  "settings_sender_dns_description": "Для нашего SMTP сервера вам необходимо настроить записи SPF и DKIM для доменов отправителя. Добавление записи DMARC также обязательно для безопасности и доставки электронной почты.",
  "settings_sender_spf_title": "Запись SPF",
  "settings_sender_spf_description": "Продолжайте добавлять указанную запись TXT к домену отправителя, выбрав один из следующих вариантов:",
  "settings_sender_dkim_title": "Запись DKIM",
  "settings_sender_dkim_description": "В настройках DNS вашего домена, выберите значение TXT и добавьте указанную запись DKIM. Она содержит открытый ключ, используемый для проверки электронных писем, отправленных с вашего домена. Это подтверждение того, что письма являются подлинными и не были подделаны во время передачи.",
  "settings_sender_dmarc_title": "Запись DMARC",
  "settings_sender_dmarc_description": "Завершите процесс аутентификации электронной почты, добавив указанную запись DMARC в настройках DNS вашего домена. Установите политику того, как получатели электронной почты должны обрабатывать сообщения, которые не проходят проверки SPF или DKIM, и тем самым обеспечьте  дополнительный уровень защиты от мошеннических действий с электронной почтой.",
  "settings_sender_domain_added": "Добавлен домен отправителя <strong>{domain}</strong>.",
  "settings_sender_domain": "Домен отправителя",
  "settings_sender_domains_name": "Имя домена",
  "settings_sender_domains_action_verify": "Проверка",
  "settings_sender_domains_action_delete": "Удалить",
  "settings_sender_domains_action_subaccount": "Дополнительная учетная запись:",
  "settings_sender_action_delete_confirm_title": "Удалить домен",
  "settings_sender_action_delete_confirm_message": "Вы уверены, что хотите удалить домен <strong>{domainName}</strong>?",
  "settings_sender_domain_description": "Укажите домен отправителя, который вы хотите проверить:",
  "settings_sender_verify_record": "TXT-запись",
  "settings_sender_verify_value": "Статус",
  "settings_sender_verify_ok": "OК",
  "settings_sender_dns_ask_admin": "Обратитесь к менеджеру вашего аккаунта, чтобы проверить домен. Это действие обязательно и может быть выполнено только владельцем основного аккаунта.",
  "settings_sender_verify_fail": "{type} не найден или неправильно настроен",
  "settings_sender_verified": "Ваш домен правильно настроен. Вы можете безопасно отправлять письма с помощью этого отправителя.",
  "settings_sender_dkim_domain_title": "DKIM домен",
  "settings_sender_dkim_value_title": "DKIM значение",
  "settings_sender_dmarc_domain_title": "DMAR домен",
  "settings_sender_dmarc_value_title": "DMARC значение",
  "settings_sender_domains_search_placeholder": "Фильтрация доменов отправителя по имени...",
  "settings_sender_domains_status_placeholder": "Проверка...",
  "settings_sender_domains_status_verified": "Проверено",
  "settings_sender_domains_status_not_verified": "Не проверено",
  "settings_sender_domains_filters_no_results": "Ни одной записи не найдено с этими фильтрами",
  "block_unverified_sender_title": "Блокировать непроверенные домены отправителя",
  "block_unverified_sender_modal_title": "Непроверенные домены отправителя",
  "block_unverified_sender_desc": "Если домен отправителя не проверен, заблокируйте отправку писем и уведомите меня по электронной почте",
  "block_unverified_sender_change": "Изменить этот сценарий",
  "forward_as_received_title": "Отправить без изменений",
  "forward_as_received_info": "Отправляйте письма без изменений, даже с непроверенных доменов отправителя. Помните, что это, скорее всего, приведет к <strong>высокому показателю отказов и низкому уровню доставки</strong>, поскольку ваши письма могут быть помечены как спам. Это повлияет на репутацию домена отправителя.",
  "block_title": "Отклонить и удалить",
  "block_info": "Выберите этот параметр, чтобы гарантировать, что письма с непроверенных доменов отправителя не будут отправляться. Сообщения, не прошедшие проверки SPF, DKIM или DMARC, будут автоматически удалены, чтобы <strong>сохранить репутацию отправителя</strong> и предотвратить риск доставки в спам.",
  "fallback_to_turbo_title": "Повторная конвертация отправителя",
  "fallback_to_turbo_info": "Выберите повторную конвертацию, чтобы использовать адрес turboSMTP в качестве отправителя для писем с непроверенных доменов. Это может улучшить доставку, хотя получатели в своих почтовых клиентах могут заметить изменение <strong>адреса отправителя</strong>.",
  "notification_email_updated": "Уведомление по электронной почте обновлено.",
  "notification_email_enabled": "Уведомление по электронной почте включено.",
  "notification_email_disabled": "Уведомление по электронной почте отключено.",
  "invalid_notification_email": "Уведомление по электронной почте недействительно",
  "settings_sender_domains_new_intro": "Введите информацию о новом домене",
  "no_records_found": "Запись DNS не найдена. Убедитесь, что запись правильно опубликована и распространение завершено.",
  "invalid_record_found": "Запись DNS найдена, но, по-видимому, она некорректно отформатирована или содержит недопустимое значение.",
  "too_many_dns_lookups": "Запись SPF включает более допустимого предела в 10 DNS-запросов, что может вызвать проблемы с доставкой электронной почты.",
  "more_than_spf_entry_found": "Обнаружено несколько записей SPF для вашего домена. Допускается только одна запись SPF на домен.",
  "settings_sender_loading_domain_data": "Загрузка результатов проверки домена...",
  "notice": "Предупреждение",
  "settings_sender_domains_no_option": "<p>Ваш аккаунт в настоящее время работает в \"стандартном режиме\", более <strong>старой конфигурации</strong>, которая перепаковывает все исходящие письма с использованием нашего адреса электронной почты, независимо от ваших настроек SPF, DKIM и DMARC.</p>\n<p>Чтобы улучшить доставляемость электронной почты, мы настоятельно рекомендуем выбрать один из доступных обновленных вариантов резервирования.</p>",
  "failed_to_get_a_aaaa_record": "Не удалось получить записи A / AAAA для {domain_name}",
  "invalid_spf_syntax": "Неверный синтаксис SPF",
  "spf_has_upper_case_letters": "Запись SPF не должна содержать заглавные буквы. Пожалуйста, убедитесь, что все символы написаны строчными буквами, чтобы соответствовать спецификации SPF.",
  "recursive_include_detected": "В записи SPF не должен быть включен сам домен, так как это приводит к зацикливанию и бесконечным DNS-запросам. Пожалуйста, исправьте запись SPF, чтобы исключить ссылку на домен, избежать циклических зависимостей и соответствовать спецификации SPF.",
  "spf_longer_than_255_characters": "Запись SPF превышает предел в 255 символов для одной текстовой строки DNS. Чтобы соответствовать спецификациям DNS, пожалуйста, разделите вашу запись SPF на несколько строк, каждая из которых не превышает 255 символов, или сократите запись, чтобы соответствовать установленному лимиту.",
  "ptr_mechanism_not_allowed": "Для оптимизации производительности SPF и содействия принятию надежных практик проверки отправителей рекомендуется исключить механизм ptr и вместо этого полагаться на такие механизмы, как ip4 и include.",
  "data_location_modal_title": "Расположение данных",
  "data_location_network_servers": "Сетевые серверы",
  "data_location_ip_location": "Расположение IP",
  "data_location_company_managing_data": "Компания, управляющая данными",
  "data_location_network_servers_value": "Милан (IT), Франкфурт (DE), Амстердам (NL)",
  "data_location_ip_location_value": "Европа RI.PE",
  "data_location_company_managing_data_value": "Edisplay Srl, Италия EU",
  "data_location_no_transfer_outside_eu": "Данные не передаются за пределы Европейского Союза",
  "gdpr_data_location": "Все данные в ЕС",
  "gdpr_see_details": "Подробнее",
  "settings_apikeys_ips_label": "Ограничение по IP",
  "settings_apikeys_permissions_label": "Разрешения API",
  "settings_apikeys_permissions_description": "Выберите службы, к которым этот ключ API может получить доступ.",
  "settings_apikeys_permission_send_smtp": "Отправка SMTP",
  "settings_apikeys_permission_send_api": "Отправка HTTP API",
  "settings_apikeys_permission_apis": "Статистика и API управления",
  "settings_apikeys_permissions_required": "Пожалуйста, выберите хотя бы один вариант",
  "settings_apikeys_legacy_key_alert_message": "Мы обновили нашу <strong>аутентификацию SMTP</strong>, чтобы использовать <strong>ключи API</strong> вместо пароля вашей учетной записи.<br>Чтобы обеспечить плавный переход, <strong>мы создали для вас специальный ключ API</strong>, который соответствует вашим старым учетным данным. Для повышения безопасности мы настоятельно рекомендуем <strong>удалить этот ключ и создать новый</strong> для использования в ваших настройках SMTP.",
  "settings_apikeys_legacy_key_alert_link": "Подробнее",
  "settings_apikeys_apikey_new_security_copy_cta": "Копировать в буфер обмена",
  "settings_apikeys_apikey_new_security_copied_success": "Скопировано!",
  "settings_apikeys_apikey_new_security_error": "Ошибка копирования",
  "settings_apikeys_action_regenerate_secret": "Создать новый пароль пользователя",
  "settings_apikeys_action_regenerate_secret_confirmation_message": "При создании нового пароля пользователя весь код, использующий существующий ключ, перестанет работать.",
  "settings_apikeys_action_regenerate_secret_confirmation": "Я понимаю, создайте новый пароль пользователя",
  "settings_apikeys_action_regenerate_secret_success": "Новый пароль пользователя создан!",
  "not_included_in_plan": "Не включено в ваш текущий план",
  "registration_logout": "Выйти",
  "registration_step_personal": "Личная информация",
  "registration_step_company": "Информация о компании",
  "registration_step_address": "Адрес",
  "registration_label_email": "Email",
  "registration_label_firstname": "Имя",
  "registration_label_lastname": "Фамилия",
  "registration_label_company": "Компания",
  "registration_label_vat": "ИНН / НДС",
  "registration_label_vat_optional": "(Необязательно)",
  "registration_label_phone": "Номер телефона",
  "registration_label_website": "Веб-сайт",
  "registration_label_website_hint": "(Необязательно)",
  "registration_label_address": "Адрес",
  "registration_label_city": "Город",
  "registration_label_country": "Страна",
  "registration_placeholder_country": "Выберите страну",
  "registration_label_region": "Область / Регион",
  "registration_placeholder_region": "Выберите регион",
  "registration_label_zip": "Почтовый индекс",
  "registration_btn_back": "Назад",
  "registration_btn_next": "Следующий шаг",
  "registration_btn_complete": "Завершить профиль",
  "registration_error_firstname": "Имя обязательно.",
  "registration_error_lastname": "Фамилия обязательна.",
  "registration_error_company": "Компания обязательна.",
  "registration_error_phone": "Номер телефона обязателен.",
  "registration_error_website": "Пожалуйста, введите корректный URL.",
  "registration_error_address": "Адрес обязателен.",
  "registration_error_city": "Город обязателен.",
  "registration_error_country": "Страна обязательна.",
  "registration_error_region": "Регион обязателен.",
  "registration_error_zip": "Почтовый индекс обязателен.",
  "registration_error_phone_format": "Номер телефона должен содержать только цифры.",
  "registration_address_message": "Убедившись, что ваш почтовый адрес верен, вы сможете воспользоваться <strong>ускоренной активацией</strong>.",
  "registration_step_confirmation": "Подтверждение",
  "registration_confirmation_title": "Профиль заполнен!",
  "registration_confirmation_message": "Ваша учетная запись была успешно создана.<br>Теперь вы можете приобрести тарифный план, чтобы разблокировать расширенные функции и более высокие лимиты на отправку",
  "registration_confirmation_message_buy": "Ваша учетная запись была успешно создана.",
  "registration_btn_buy_plan": "Купить тарифный план",
  "registration_stay_free": "Остаться на бесплатной версии, обновить тариф позже",
  "registration_btn_dashboard": "Перейти в панель управления",
  "registration_redirect_to_shop": "Через мгновение вы будете перенаправлены к процессу оплаты...",
  "registration_go_to_shop": "Нажмите здесь, чтобы перейти к оплате",
  "button_yes_delete": "Да, удалить",
  "button_yes_revoke": "Да, отозвать"
}
